// @flow

import ApiClient from 'speed-js-core/src/api/ApiClient';
import Resource from 'speed-js-core/src/api/Resource';

export default class WorkflowResource extends Resource {
    basePath: string = 'workflows/';

    constructor(client: ApiClient) {
        super(client);

        delete this.schema;
        delete this.list;
        delete this.get;
        delete this.create;
        delete this.update;
        delete this.delete;
    }

    start(path: string, data: Object, env?: Object): Promise<{
        id: string,
        state: string,
    }> {
        const body: Object = { path, data };
        if (env) {
            body.env = env;
        }
        return this.client._request(`${this.basePath}start/`, 'POST', body).then((response) => response.data);
    }

    resume(executionId: string, data: Object, env?: Object): Promise<{
        id: string,
        state: string,
    }> {
        const body: Object = { data };
        if (env) {
            body.env = env;
        }
        return this.client._request(
            `${this.basePath}${executionId}/resume/`,
            'PUT', body,
        ).then((response) => response.data);
    }

    validateSerializerData(serializerPath: string, data: Object): Promise<{
        id: string,
        state: string,
    }> {
        const body: Object = { serializer_path: serializerPath, data };
        return this.client._request(`${this.basePath}validate_serializer_data/`, 'POST', body)
            .then((response) => response.data);
    }

    status(executionId: string): Promise<string> {
        return this.client._request(
            `${this.basePath}${executionId}/status/`, 'GET',
        ).then((response) => response.data.status);
    }
}
